import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "@phosphor-icons/react";
import { FadeIn, Stagger, StaggerItem } from "../components/Motion";
import { SERVICES } from "../data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="pt-36 pb-20 md:pt-44 md:pb-28 text-center">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <FadeIn>
            <div className="flex items-center justify-center gap-6 mb-8">
              <div className="h-[1px] w-16 bg-[#0b2e5e]/20" />
              <span className="issue-stripe">§ 03 · The Practice</span>
              <div className="h-[1px] w-16 bg-[#0b2e5e]/20" />
            </div>
            <h1 className="font-display text-5xl sm:text-7xl lg:text-[108px] tracking-[-0.03em] font-semibold leading-[0.9] text-[#0b2e5e]">
              Seven disciplines,
              <br />
              <span className="font-serif-italic text-[#1d4ed8]">one</span> compound team.
            </h1>
          </FadeIn>
          <FadeIn delay={0.15}>
            <p className="mt-10 max-w-2xl mx-auto text-lg md:text-xl text-[#0b2e5e]/75 leading-relaxed">
              We staff lean, senior pods that move between strategy, design and engineering without handoffs.
              Every engagement is scoped around the outcome you actually need.
            </p>
          </FadeIn>
          <FadeIn delay={0.3}>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
              <div className="sticker"><span className="dot" style={{ background: "#14B8A6" }} /> Digital Marketing</div>
              <div className="sticker"><span className="dot" style={{ background: "#F97316" }} /> Branding &amp; Brand Identity</div>
              <div className="sticker"><span className="dot" style={{ background: "#8B5CF6" }} /> Web Design &amp; Development</div>
              <div className="sticker"><span className="dot" style={{ background: "#EAB308" }} /> Photography &amp; Videography</div>
              <div className="sticker"><span className="dot" style={{ background: "#E11D48" }} /> Creative Designs</div>
              <div className="sticker"><span className="dot" style={{ background: "#3B82F6" }} /> Motion Graphics</div>
              <div className="sticker"><span className="dot" style={{ background: "#3B82F6" }} /> Events &amp; Exhibitions</div>
            </div>
          </FadeIn>
        </div>
      </section>

      <section className="pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-6">
          {SERVICES.map((s, i) => (
            <FadeIn key={s.id} delay={i * 0.05}>
              <div
                className="glass tracing-border rounded-3xl p-8 md:p-12 grid md:grid-cols-12 gap-8 group"
                data-testid={`service-card-${s.id}`}
              >
                <div className="md:col-span-1 font-mono-mini text-[#0b2e5e]/50">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="md:col-span-5">
                  <div
                    className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-mono-mini mb-4"
                    style={{ background: `${s.accent}18`, color: s.accent, border: `1px solid ${s.accent}55` }}
                  >
                    <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.accent }} />
                    {s.tagline}
                  </div>
                  <h3 className="font-display text-4xl md:text-5xl tracking-tight leading-[0.95]">
                    {s.title}
                  </h3>
                  <p className="text-[#0b2e5e]/65 mt-6 text-base md:text-lg leading-relaxed max-w-lg">
                    {s.description}
                  </p>
                </div>
                <div className="md:col-span-6 md:border-l md:border-[#0b2e5e]/12 md:pl-8">
                  <div className="font-mono-mini text-[#0b2e5e]/50 mb-4">Deliverables</div>
                  <ul className="space-y-3">
                    {s.deliverables.map((d) => (
                      <li key={d} className="flex items-start gap-3">
                        <span
                          className="mt-1 flex h-5 w-5 items-center justify-center rounded-full shrink-0"
                          style={{ background: `${s.accent}22`, border: `1px solid ${s.accent}88` }}
                        >
                          <Check weight="bold" size={12} style={{ color: s.accent }} />
                        </span>
                        <span className="text-[#0b2e5e]/85">{d}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
          <FadeIn>
            <h2 className="font-display text-4xl md:text-6xl">
              Ready to partner?
            </h2>
            <p className="mt-6 text-[#0b2e5e]/65 max-w-2xl mx-auto">
              Every engagement starts with a no-pressure discovery call. We'll talk through your goals and share whether we're a fit.
            </p>
            <Link to="/contact" className="btn-primary mt-10" data-testid="services-cta-contact">
              Book a call <ArrowUpRight weight="bold" size={16} />
            </Link>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
